var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$auth.ready())?_c('div',{attrs:{"id":"app"}},[(_vm.$auth.check())?_c('div',[_c('Header'),_c('Sidebar',{attrs:{"collapsed":_vm.isCollapsed},on:{"sideBarToggled":_vm.changeContentWidth}})],1):_vm._e(),_c('Content',{attrs:{"paddingClass":_vm.contentClass}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }